import React from 'react'

import type { CollapsibleContextProps } from './CollapsibleContext'
import { useCollapsibleContext } from './CollapsibleContext'

export type CollapsibleTriggerProps = {
  children: (contextState: CollapsibleContextProps) => React.ReactNode
}

export const CollapsibleTrigger = ({
  children: renderChildren,
}: CollapsibleTriggerProps) => {
  const contextState = useCollapsibleContext()

  return <>{renderChildren(contextState)}</>
}
